import { ref } from "vue";
import api from "@/api/api";
import {toast} from "@/components/utils/ui_v4/alerts/toast/toast";

export default function useDetalhesCotacaoHistoricoTab() {
    const historyFilters = [
        { id: 'todos', label: 'Todos' },
        { id: 'criacao_edicao', label: 'Criação/edição' },
        { id: 'vigencia', label: 'Vigência' },
        { id: 'propostas', label: 'Propostas' },
        { id: 'decisoes_ganhador', label: 'Decisões de ganhador' },
        { id: 'pedidos', label: 'Pedidos' },
        { id: 'auditoria_geral', label: 'Auditoria geral' }
    ];

    const activeHistoryFilter = ref('todos');
    const historyEvents = ref([]);

    const fetchHistoryLogs = async (idCotacao) => {
        if (!idCotacao) return;
        try {
            historyEvents.value = [];
            const params = {};
            if (activeHistoryFilter.value && activeHistoryFilter.value !== 'todos') {
                params.tipo_acao = activeHistoryFilter.value;
            }

            const { data } = await api.get(`/cotacao/listar_logs_cotacao/${idCotacao}`, { params });

            if (data.success) {
                historyEvents.value = data.logs.map(log => {
                    const [date, time] = log.created_at.split(' ');
                    return {
                        id: log.id,
                        date,
                        time,
                        description: log.description
                    };
                });
            }
        } catch (error) {
            toast.error("Erro ao buscar logs da cotação!");
            
        }
    };

    return {
        historyFilters,
        activeHistoryFilter,
        historyEvents,
        fetchHistoryLogs
    };
}
